import React, { useEffect, useState } from "react"
import {
  arrayPush,
  change,
  Field,
  FieldArray,
  formValueSelector,
  getFormSyncErrors,
  setSubmitFailed,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { TextField, CheckboxField } from "components/RenderInput"
import { connect } from "react-redux"
import { renderResultsForm } from "./utils"
import ModalComponent from "components/Modals"
import { displayLockWarningModal, postQuestionnaireResult } from "store/actions"
import { mapQuestionnaireResultToApi } from "../utils"
import { minPointsCalculator, maxPointsCalculator } from "./utils"
import PropTypes from "prop-types"
import ResultPreview from "./resultPreview"

const CreateResult = props => {
  const [isResultSubmitFailedModalOpen, setIsResultSubmitFailedModalOpen] =
    useState(false)
  useEffect(() => {
    if (
      props.questionnaireResults &&
      Object.keys(props.questionnaireResults).length > 0
    ) {
      props.change(
        "questionnaire_form.createResult.description",
        props.questionnaireResults?.disclaimer
      )
      props.change(
        "questionnaire_form.createResult.displayDate",
        props.questionnaireResults.display_submission_datetime === 1
      )
      props.change(
        "questionnaire_form.createResult.headline",
        props.questionnaireResults.headline
      )
      props.change(
        "questionnaire_form.createResult.results",
        props.questionnaireResults.resultsets.map(result => ({
          bottomGradientColor: result.bottom_color,
          textColor: result.font_color,
          maxScore: result.max_value,
          minScore: result.min_value,
          title: result.title,
          description: result.text,
          topGradientColor: result.top_color,
        }))
      )
      props.change(
        "questionnaire_form.createResult.storingPeriod",
        props.questionnaireResults.storing_period.toString()
      )
    }
  }, [props.questionnaireResults])

  const submitHandler = () => {
    if (!props.feature.entity_id) {
      setIsResultSubmitFailedModalOpen(true)
      return
    }
    if (
      !(
        props.formSyncErrors.hasOwnProperty("questionnaire_form") &&
        props.formSyncErrors?.questionnaire_form.hasOwnProperty("createResult")
      )
    ) {
      props.postQuestionnaireResult(
        mapQuestionnaireResultToApi({
          ...props.createResultsFormValue,
          entity_id: props.feature.entity_id,
          vendorId: props.vendorId,
        })
      )
    } else {
      props.setSubmitFailed(["questionnaire_form.createResult"])
    }
  }

  const handleFieldFocus = event => {
    if (props?.hasReplies) {
      event.preventDefault()
      props.displayLockWarningModal()
    }
  }

  return (
    <>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <h3>Results</h3>
            </Col>
            <Col xs="auto" className="mx-3">
              <SaveButton
                content="Save"
                type="button"
                onClick={submitHandler}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Row className="my-3 align-items-center">
                <Col xs="auto">
                  <span>Time to store data:</span>
                </Col>
                <Col xs={2} className="p-0">
                  <Field
                    name="storingPeriod"
                    component={TextField}
                    type="number"
                    onFocus={handleFieldFocus}
                    onChange={handleFieldFocus}
                  />
                </Col>
                <Col xs="auto">
                  <span>days</span>
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <span>
                    To create each result screen give a score range and a result
                    description. The result screens should be created from the
                    lowest score range to the highest.
                    <br />
                    (For example, if your score = 1-5 You are a Novice, if your
                    score = 6-10 You are On Your Way, if your score = 11-15 You
                    are an Expert)
                  </span>
                </Col>
              </Row>
              <Card>
                <CardHeader>
                  <h4>HEADLINE/DESCRIPTION</h4>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col>
                      <Field
                        name="headline"
                        component={TextField}
                        label="Headline"
                        onFocus={handleFieldFocus}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      <Field
                        name="description"
                        component={TextField}
                        label="Description"
                        onFocus={handleFieldFocus}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h4>DEFINE RESULTS BY TOTAL SCORE</h4>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col>
                      <span>
                        Scores are added together. Define the Result by the
                        total score.
                        <br />
                        <b>
                          Minimum points currently:{" "}
                          {minPointsCalculator(props.createFormValue)} points
                        </b>
                        <br />
                        <b>
                          Maximum points currently:{" "}
                          {maxPointsCalculator(props.createFormValue)} points
                        </b>
                        <br />
                        <b>Results should cover all possible scores.</b>
                      </span>
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col>
                      <Field
                        name="displayDate"
                        label="Display submission date and time on Results page"
                        component={CheckboxField}
                        onChange={handleFieldFocus}
                      />
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col>
                      <FieldArray
                        name="results"
                        component={renderResultsForm}
                        rerenderOnEveryChange={true}
                        handleFieldFocus={handleFieldFocus}
                        hasReplies={props?.hasReplies}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <h5
                        style={{ cursor: "pointer" }}
                        onClick={
                          props?.hasReplies
                            ? () => {}
                            : () => {
                                const maxScores = props?.results?.map(
                                  x => x?.maxScore
                                )
                                const maxValue = Math.max(...maxScores)
                                props.addQuestionForm(
                                  "questionnaire_form.createResult.results",
                                  {
                                    minScore: maxValue + 1,
                                    maxScore: maxValue + 2,
                                    topGradientColor: "#AFECA7",
                                    bottomGradientColor: "#94BE82",
                                    textColor: "#FFFFFF",
                                  }
                                )
                              }
                        }
                      >
                        + Add Another Result
                      </h5>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Row className="my-2">
                <Col className="d-flex justify-content-center">
                  <SaveButton
                    content="Save"
                    type="button"
                    onClick={submitHandler}
                  />
                </Col>
              </Row>
            </Col>
            <Col xl={4} className="mt-4 custom-features-preview">
              <ResultPreview
                menu_bg_color={props.design?.menu_bg_color}
                menu_font_color={props.design?.menu_font_color}
                headline={props.formValues?.createResult?.headline}
                description={props.formValues?.createResult?.description}
                bgImage={
                  props.formValues?.createDesign?.backgroundImage?.editedImage
                }
                image={props.formValues?.createDesign?.image?.editedImage}
                bgColor={props.formValues?.createDesign?.backgroundColor}
                results={props?.formValues?.createResult?.results}
                textColor={props.formValues?.createDesign?.textColor}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ModalComponent
        title={"Unable to store results"}
        open={isResultSubmitFailedModalOpen}
        onClose={() => {
          setIsResultSubmitFailedModalOpen(false)
        }}
      >
        <Row>
          <h5>
            Before saving the results, you need to actually create the
            questionnaire.
          </h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              content="Ok"
              onClick={() => {
                setIsResultSubmitFailedModalOpen(false)
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </>
  )
}

const selector = formValueSelector(FORM_NAMES.QUESTIONNAIRE)

const mapStateToProps = state => ({
  createFormValue: selector(state, "questionnaire_form.create"),
  createResultsFormValue: selector(state, "questionnaire_form.createResult"),
  formSyncErrors: getFormSyncErrors(FORM_NAMES.QUESTIONNAIRE)(state),
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  questionnaireResults: state.Questionnaire.questionnaireResults,
  formValues: selector(state, "questionnaire_form"),
  results: selector(state, "questionnaire_form.createResult.results"),
})

const mapDispatchToProps = dispatch => ({
  setSubmitFailed: fields =>
    dispatch(setSubmitFailed(FORM_NAMES.QUESTIONNAIRE, ...fields)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.QUESTIONNAIRE, `${field}`, value)),
  addQuestionForm: (field, values) =>
    dispatch(arrayPush(FORM_NAMES.QUESTIONNAIRE, field, values)),
  postQuestionnaireResult: values => dispatch(postQuestionnaireResult(values)),
  displayLockWarningModal: () => dispatch(displayLockWarningModal()),
})

CreateResult.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateResult)
